module.exports = __webpack_public_path__ + "img/LG fc Simone Busscher V2.b078007a.png";